import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { HttpClient } from "../../../api/httpClient";
import { DEFAULT_ENTITY_STATE } from "../../utils";

const baseName = "projects";

const initialState = {
  personal: DEFAULT_ENTITY_STATE,
  approver: DEFAULT_ENTITY_STATE,
  financial: DEFAULT_ENTITY_STATE,
  admin: DEFAULT_ENTITY_STATE,
  director: DEFAULT_ENTITY_STATE,
};

export const getProjects = createAsyncThunk(
  `${baseName}/getProjects`,
  async (role) => {
    const res = await HttpClient.get({
      url: "/projects",
      params: {
        role,
      },
    });
    return res?.data;
  }
);

export const projectsSlice = createSlice({
  name: baseName,
  initialState,
  reducers: {
    setupProjects(state, { payload }) {
      const { data, role } = payload || {};
      if (!state[role]) return;
      //CONFIGURAR ENTRADA DE DADOS
      state[role].data =
        data?.map((item) => ({ ...item, id: item?._id })) || [];
    },

    //ADM ACTIONS
    addProject(state, { payload }) {
      state.admin.data.push(payload);
    },
    updateProject(state, { payload }) {
      const { id, changes } = payload;
      const index = state.admin.data.findIndex((item) => item.id === id);
      if (index !== -1) {
        state.admin.data[index] = {
          ...state.admin.data[index],
          ...changes,
        };
      }
    },
    removeProject(state, { payload }) {
      state.admin.data = [
        ...state.admin.data?.filter((item) => item?.id !== payload),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjects.pending, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "loading";
        state[role].error = null;
      })
      .addCase(getProjects.rejected, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "failed";
        state[role].error = action.error.message || null;
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        const role = action.meta.arg || "personal";
        state[role].status = "succeeded";
        state[role].error = null;

        //Dados API
        const data = action.payload || [];
        projectsSlice.caseReducers.setupProjects(state, {
          payload: {
            data,
            role,
          },
        });
      });
  },
});

export const { addProject, removeProject, setupProjects, updateProject } =
  projectsSlice.actions;

export default projectsSlice.reducer;

export const selectProjectsByRole = createSelector(
  [(state) => state.projects, (state, role) => role],
  (projectsState = {}, role = "") => {
    const prevData = projectsState[role] || DEFAULT_ENTITY_STATE;

    return {
      ...prevData,
      total: prevData?.data?.length || 0,
    };
  }
);

export const selectProjectById = createSelector(
  [selectProjectsByRole, (state, role, projectId) => projectId],
  (projectsState = {}, projectId = "") => {
    return projectsState?.data?.find((item) => item?.id === projectId) || {};
  }
);
